<template>
	<div>
		<div class="cards">
			<div class="vx-row">
				<div class="vx-col w-full mb-base">
					<vx-card title="Abonnement">
						<template slot="actions">
							<vx-tooltip class="flex" text="Hoe en wat?">
								<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
							</vx-tooltip>
						</template>
						Op deze pagina kan je je abonnement kiezen. Een upgrade is direct actief! Wil je een stapje terug? Dan gaat het geselecteerde abonnement de eerste
						van volgende maand in.
					</vx-card>
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col lg:w-1/3 md:w-1/2 w-full mb-base" v-for="subscription in this.availableSubscriptions"
					 v-bind:key="subscription.name">
					<vx-card v-bind:title="subscription.name">
						<div class="vx-row subscriptionCards">
							<div class="vx-col w-1/3">Bestellingen<br>
								<div class="vx-col" v-if="subscription.max_boundry !== null">{{
										subscription.max_boundry
									}}
								</div>
								<div class="vx-col" v-if="subscription.max_boundry !== null">per maand</div>
								<div class="vx-col" v-if="subscription.max_boundry == null">Onbeperkt</div>
							</div>
							<div class="vx-col w-1/3">
								<div class="vx-col" v-if="subscription.price !== '0'">€ {{ subscription.price }}</div>
								<div class="vx-col" v-if="subscription.price !== '0'">per maand</div>
								<div class="vx-col" v-if="subscription.price == '0'">Gratis</div>
							</div>
							<div class="vx-col w-1/3">
								<div class="vx-col">Hulp</div>
								<div class="vx-col" v-if="subscription.price !== '0'">
									<font-awesome-icon icon="envelope" />
									<font-awesome-icon icon="phone-alt" />
									<font-awesome-icon icon="comment" />
								</div>
								<div class="vx-col" v-if="subscription.price == '0'">
									<font-awesome-icon icon="envelope" />
									<font-awesome-icon icon="comment" />
								</div>
							</div>
						</div>
						<br>
						<div class="vx-row">
							<div class="vx-col"
								 v-if="subscription.id !== currentSubscription.id && subscription.id !== nextSubscriptions.id">
								<vs-button @click.native="openConfirmPopup(subscription)">Kies dit
									abonnement
								</vs-button>
							</div>
							<div class="vx-col" v-if="subscription.id == currentSubscription.id">
								<vs-button color="success">Actief
									abonnement
								</vs-button>
							</div>
							<div class="vx-col"
								 v-if="subscription.id == nextSubscriptions.id && nextSubscriptions.id !== currentSubscription.id">
								<vs-button color="success">Gaat volgende maand in
								</vs-button>
							</div>
						</div>
					</vx-card>
				</div>
			</div>
		</div>
		<div class="popup">
			<vs-popup :active.sync="confirmPopup" title="Bevestig">
				<div class="vx-row">
					<div class="vx-col w-full"><h4>Weet je zeker dat je het {{ selectedSubscriptionName.name }}
						abonnement wilt?</h4></div>
					<div class="vx-col w-full" v-if="selectedSubscription.subscription_id < currentSubscription.id">Het
						abonnement gaat de eerst volgende
						maand
						in
					</div>
					<div class="vx-col w-full" v-if="selectedSubscription.subscription_id > currentSubscription.id">Het
						abonnement gaat meteen in
					</div>
					<div class="vx-col w-full"><br></div>
					<div class="vx-col w-1/2">
						<vs-button class="w-full" @click.native="updateSubscription()">Ja</vs-button>
					</div>
					<div class="vx-col w-1/2">
						<vs-button class="w-full" type="border" color="danger" @click.native="confirmPopup = false">Nee
						</vs-button>
					</div>
				</div>
			</vs-popup>
		</div>
		<div>* Alle genoemde prijzen zijn exclusief 21% BTW</div>
	</div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
	name: 'Subscriptions',
	data() {
		return {
			confirmPopup: false,
			currentSubscription: {},
			selectedSubscriptionName: '',
			selectedSubscription: {
				subscription_id: '',
				next_subscription_id: '',
			},
			availableSubscriptions: {},
		}
	},
	mounted() {
		if (!this.$store.state.subscriptions.subscription) {
			this.getData()
		} else {
			this.setData()
		}
	},
	methods: {
		...mapActions({
			subscription: 'subscriptions/getSubscriptions'
		}),
		wiki() {
			window.open(this.$store.state.wiki.wiki.subscription)
		},
		getData() {
			this.$vs.loading();
			this.$store.dispatch('subscriptions/getSubscriptions').then(res => {
				this.setData()
			}).catch(error => {
				this.$vs.loading.close();
				this.showError()
			});
		},
		setData() {
			this.currentSubscription = this.$store.state.subscriptions.subscription.current;
			this.availableSubscriptions = this.$store.state.subscriptions.subscription.available;
			this.nextSubscriptions = this.$store.state.subscriptions.subscription.next;
			this.$vs.loading.close();
		},
		openConfirmPopup(selectedSubscription) {
			this.confirmPopup = true;
			this.selectedSubscription.subscription_id = selectedSubscription.id;
			this.selectedSubscription.next_subscription_id = selectedSubscription.id;
			this.selectedSubscriptionName = selectedSubscription;
		},
		updateSubscription() {
			this.$vs.loading();
			this.selectedSubscription.next_subscription_id = this.selectedSubscription.subscription_id;
			if (this.selectedSubscription.subscription_id < this.currentSubscription.id) {
				this.selectedSubscription.subscription_id = this.currentSubscription.id;
			}
			this.$store.dispatch('subscriptions/updateSubscriptions', this.selectedSubscription).then(res => {
				this.getData();
				this.confirmPopup = false;
				this.$vs.notify({
					color: 'success',
					title: 'Gelukt!',
					text: 'Je abonnement is gewijziged',
				})
			}).catch(error => {
				this.$vs.loading.close();
				this.showError();
			});
		},
		showError() {
			this.$vs.notify({
				color: 'danger',
				title: 'Oops!',
				text: 'er is iets mis gegaan, probeer het straks opnieuw',
			});
		},
	}
}
</script>

<style scoped>
.subscriptionCards div {
	display: block;
	margin: 0 auto;
	text-align: center;
}
</style>
